module.exports = __webpack_public_path__ + "static/media/events-icon-active-check.780dad59.png";